"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

var isNotNil = function isNotNil(obj) {
  return !(0, _isNil["default"])(obj);
};

var _default = isNotNil;
exports["default"] = _default;